import RemoveCircle from 'assets/icons/RemoveCircle'
import { NavBar } from 'components/NavBar/NavBar'
import { NoData } from 'components/NoData'
import { Pagination } from 'components/Pagination/Pagination'
import { setConfirmModal } from 'features/global/globalSlice'
import { deleteRolePermissionPolicy } from 'features/roles/clientRolesSlice'
import { clearRolePermissionPolicyTemplatesList, deleteRolePermissionPolicyTemplate, getRolePermissionPolicyTemplates } from 'features/roles/roleTemplatesSlice'
import useQueryPagination from 'hooks/useQueryPagination'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { AppDispatch, RootState } from 'store'
import { Button, Flex, GridItem, H1WithBack, ItemsGrid, PageFooter, PageWrapper } from 'styling/GlobalStyles'
import { ModalTypes } from 'types/global.interface'
import { getParams, handlePagination } from 'utils/helpers'

export const RolePermissionPolicyTemplates = () => {
    const [params, setParams] = useState<any>(getParams({ location, limit: 30 }))
    const { permissionPolicyTemplates } = useSelector((state: RootState) => state.roleTemplates)
    const navigate = useNavigate()
    const dispatch = useDispatch<AppDispatch>()

    useQueryPagination({ fetchFunctions: [getRolePermissionPolicyTemplates], cleanUpFunctions: [clearRolePermissionPolicyTemplatesList], params })

    const removePolicyTemplate = (id: number, e) => {
        e.stopPropagation()
        dispatch(
            setConfirmModal({
                isOpen: true,
                onSave: async () => {
                    await dispatch(deleteRolePermissionPolicyTemplate(id))
                },
                setParams: {
                    type: ModalTypes.Delete,
                    f: setParams,
                },
                word: 'delete policy template',
            }),
        )
    }

    return <>
        <NavBar />
        <PageWrapper>
            <Flex between center mb='16' >
                <H1WithBack arrow title='Permission Policy Templates' />
                <Button orange onClick={() => navigate('add')}>
                    Add Policy Template
                </Button>
            </Flex>
            <ItemsGrid columns={3} mt='25px'>
                {permissionPolicyTemplates?.data.length ? permissionPolicyTemplates.data.map(({ policyName, id }) => {
                    return (
                        <GridItem key={id} onClick={() => navigate('single-permission/' + id.toString())}>
                            <p>
                                {policyName}
                            </p>

                            <Flex between center onClick={(e) => removePolicyTemplate(id, e)}>
                                <RemoveCircle />
                            </Flex>
                        </GridItem>
                    )
                })
                    : (
                        <NoData />
                    )}
            </ItemsGrid>

        </PageWrapper>
        <PageFooter>
            <Pagination
                setPage={(page) => handlePagination(page, setParams)}
                pageCount={Math.ceil(permissionPolicyTemplates.totalPages)}
                forcePage={(params.page ? params.page : 1) - 1}
            />
        </PageFooter>
    </>
}